import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { get } from 'lodash'
import { Input, InputDate, Select, Checkbox } from 'components/fields'
import { Module } from 'components/misc'
import activeAward from 'helpers/activeAward'
import { PAYMENTS } from 'constants/enums'
import Textarea from '../../../fields/Textarea/Textarea'

export default class ParticipantPayment extends PureComponent {
  static propTypes = {
    participantPaymentStates: PropTypes.array.isRequired,
    data: PropTypes.object,
    fieldPrefix: PropTypes.string,
    primary: PropTypes.bool
  }

  static defaultProps = {
    primary: true
  }

  render() {
    const { participantPaymentStates, data, fieldPrefix, primary } = this.props

    const activeIndex = activeAward(data)

    const prefix = typeof fieldPrefix === 'string'
      ? fieldPrefix
      : `awards[${activeIndex}].`

    const disableTransactionIdEdit =
      get(data, 'participantRegistration.paymentType.value') ===
        PAYMENTS.ONLINE_MASTERCARD.id ||
      get(data, 'participantRegistration.paymentType.value') ===
        PAYMENTS.PAYPAL.id ||
        get(data, 'participantRegistration.paymentType.value') ===
        PAYMENTS.GPWP.id

    return (
      <Module
        title="Payment"
        intlKey="moduleTitle.payment"
        primary={primary}
        narrow={!primary}
        grid
      >
        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Form of payment"
              intlKey="label.form_of_payment"
              name={`${prefix}paymentState.value`}
              options={participantPaymentStates}
            />
          </div>
          <div className="col-xs-6">
            <InputDate
              label="Date of payment"
              intlKey="label.date_of_payment"
              name={`${prefix}participantRegistration.awardPayment.paymentDate`}
              maxDay={moment().add(2, 'days')}
            />
          </div>
        </div>
          <div className="row">
          <div className="col-xs-6">
           <Input
                label="Payment type"
                intlKey="label.payment_type"
                name={`${prefix}participantRegistration.paymentType.translationText`}
                disabled={true}
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="Transation ID"
              intlKey="label.transation_id"
              name={`${prefix}participantRegistration.awardPayment.transactionId`}
              disabled={disableTransactionIdEdit}
            />
          </div>
            <div className="col-xs-6">
              <Textarea
                  label="Payment note"
                  intlKey="label.payment_note"
                  name={`${prefix}participantRegistration.awardPayment.paymentNote`}
              />
            </div>
          <div className="col-xs-6">
            <Checkbox
              label="Payment confirmed"
              intlKey="label.payment_confirmed"
              name={`${prefix}isPaymentConfirmed`}
              justify
            />
          </div>

        </div>
      </Module>
    )
  }
}
